<template>
  <div class="container home-page" style="margin:120px auto">
    <div class="row">
      <div class="col">
        <div class="d-flex my-3">
          <h3 class="title pr-3"> <span >{{ $t('Home.Daily_English') }}</span>
            <span>
              <span v-for="item in dailySentencesList">
                <button type="button" :class="{'active': item.id.includes(dailySentencesType) }" @click="selectType(item.id)" class="btn btn-sm btn-outline-danger ml-1">{{ item.name }}</button>
              </span>
            </span>
          </h3>
          <div class="line"></div>
        </div>
        <keep-alive>
          <DailySentence :inputAudioData="audioData"/>
        </keep-alive>
      </div>
    </div>
    <div class="row" v-if="dailyNews.length > 0">
      <div class="col-md-12">
        <div class="d-flex my-3">
          <h3 class="title d-flex align-items-center"><img style="height:26px" src="../assets/image/CNN logo.jpg" alt="" srcset="">{{ $t('Home.World_News') }}
            <span class="hint ml-2 mr-3">每週一、三、五更新</span>
          </h3>
          <div class="line" style="width:95%"></div>
        </div>
        <div>
          <keep-alive v-if="dailyNews && dailyNews.length > 0 && dailyNews[0].sections && dailyNews[0].sections.length > 0">
            <DailyNews class="pr-3 my-4"
              :inputNews="dailyNews[0]"
              :view_id="dailyNews[0].sections[0].data?.view_id"/>
          </keep-alive>
          <div v-else>
            <h4>
              {{authInfo.user.forcePreTest&&!authInfo.user.isFinishPreTest?'請先完成學前測驗': ''}}
            </h4>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="row" v-if="magEnable === false">
      <div class="col-md-4">
        <div class="d-flex mt-3">
          <h3 class="title pr-3">最新話題字</h3>
          <div class="line" style="width:95%"></div>
        </div>
        <div>
          <div v-if="hotWord">
            <div class="d-flex justify-content-between">
              <span class="rwd-hide hint">每週一更新</span>
              <span class="pointer" @click="goModalList('277')">
                <img src="../assets/image/icon&btn/icon_have_btn_function/btn_function_show_list.png" alt="">
                <span class="rwd-hide">
                  {{ $t('Home.watch_more') }}
                </span>
              </span>
            </div>
            <keep-alive>
              <div @click="goPage(hotWord.id)">
                <div class="picture image-box pointer" style="min-height: 200px; max-height: 200px;">
                  <img class="cover" :src="hotWord.cover" alt="">
                  <div v-if="normalizeCefrLevels(hotWord.cefr).length" class="image-level-list">
                    <span v-for="level in normalizeCefrLevels(hotWord.cefr)" :key="level" class="image-level-badge">{{ level }}</span>
                  </div>
                </div>
                <div class="ml-2">
                  <p class="m-0" style="font-size:1.1rem">
                    {{hotWord.name}}
                  </p>
                  <p class="m-0" style="font-size:.8rem">
                    {{hotWord.name_en}}
                  </p>
                </div>
              </div>
            </keep-alive>
          </div>
          <div v-else>
            <h4>
              {{authInfo.user.forcePreTest && !authInfo.user.isFinishPreTest ? '請先完成學前測驗' : ''}}
            </h4>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="d-flex mt-3">
          <h3 class="title pr-3">{{ $t('Home.Lets_play_in_English') }}</h3>
          <div class="line"></div>
        </div>
        <div v-if="dailyEnglish">
          <div class="d-flex justify-content-between">
            <span class="rwd-hide hint">每週四更新</span>
            <span class="pointer" @click="goModalList('282')">
              <img src="../assets/image/icon&btn/icon_have_btn_function/btn_function_show_list.png" alt="">
              <span class="rwd-hide">
                {{ $t('Home.watch_more') }}
              </span>
            </span>
          </div>
          <keep-alive>
            <div @click="goPage(dailyEnglish.id)">
              <div class="picture image-box pointer" style="min-height: 200px; max-height: 200px;">
                <img class="cover" :src="dailyEnglish.cover" alt="">
                <div v-if="normalizeCefrLevels(dailyEnglish.cefr).length" class="image-level-list">
                  <span v-for="level in normalizeCefrLevels(dailyEnglish.cefr)" :key="level" class="image-level-badge">{{ level }}</span>
                </div>
              </div>
              <div class="ml-2">
                <p class="m-0" style="font-size:1.1rem">
                  {{dailyEnglish.name}}
                </p>
                <p class="m-0" style="font-size:.8rem">
                  {{dailyEnglish.name_en}}
                </p>
              </div>
            </div>
          </keep-alive>
        </div>
        <div v-else>
          <h4>
            {{authInfo.user.forcePreTest&&!authInfo.user.isFinishPreTest?'請先完成學前測驗': ''}}
          </h4>
        </div>
      </div>
      <div class="col-md-4">
        <div class="d-flex mt-3">
          <h3 class="title pr-3">老外帶你遊臺灣</h3>
          <div class="line"></div>
        </div>
        <div v-if="travelTaiwan">
          <div class="d-flex justify-content-between">
            <span class="rwd-hide hint">每週二更新</span>
            <span class="pointer" @click="goModalList('279')">
              <img src="../assets/image/icon&btn/icon_have_btn_function/btn_function_show_list.png" alt="">
              <span class="rwd-hide">
                {{ $t('Home.watch_more') }}
              </span>
            </span>
          </div>
          <keep-alive>
            <div @click="goPage(travelTaiwan.id)">
              <div class="picture image-box pointer" style="min-height: 200px; max-height: 200px;">
                <img class="cover" :src="travelTaiwan.cover" alt="">
                <div v-if="normalizeCefrLevels(travelTaiwan.cefr).length" class="image-level-list">
                  <span v-for="level in normalizeCefrLevels(travelTaiwan.cefr)" :key="level" class="image-level-badge">{{ level }}</span>
                </div>
              </div>
              <div class="ml-2">
                <p class="m-0" style="font-size:1.1rem">
                  {{travelTaiwan.name}}
                </p>
                <p class="m-0" style="font-size:.8rem">
                  {{travelTaiwan.name_en}}
                </p>
              </div>
            </div>
          </keep-alive>
        </div>
        <div v-else>
          <h4>
            {{authInfo.user.forcePreTest&&!authInfo.user.isFinishPreTest?'請先完成學前測驗': ''}}
          </h4>
        </div>
      </div>
    </div> -->
    <div class="row" v-if="magEnable === true">
      <div class="col">
        <div class="d-flex my-3">
          <h3 class="title pr-3">當期訂閱雜誌
          </h3>
          <div class="line"></div>
        </div>
          <div class="d-flex flex-wrap">
            <div class="item-flex" v-for="(item, index) in channels" :key="index">
              <div class="my-2">
                <div v-if="item.child.length>0" class="christmas-magazine-cover" style="text-align:center;" @click="goMag(item)">
                  <img class="m-auto pointer magazine" style="width:100%" :src="item.cover" alt="">
                </div>
                <div class="magazine-disable christmas-magazine-cover" v-else style="text-align:center;">
                  <img class="m-auto"  style="width:100%;" :src="item.cover" alt="">
                  <div class="disable-box">
                    <h5 style="white-space: nowrap;">尚未訂閱</h5>
                  </div>
                </div>
                <div class="magazine-name"><h5>{{item.name}}</h5></div>
              </div>
              <div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="recentLessons.length>0 && magEnable === false">
      <div class="col">
        <div class="d-flex mt-3">
          <h3 class="title pr-3 latest-title">{{ $t('Home.Latest_Courses') }}
            <span class="latest-title-new">NEW</span>
          </h3>
          <div class="line"></div>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <!-- <span class="rwd-hide hint">天天上架，快來學習</span> -->
        </div>
        <div class="row my-3 mx-1">
          <div class="col-lg-3 col-md-6 col-12 mb-3" v-for="(item, index) in recentLessons.slice(0,8)" :key="index">
            <div @click="goPage(item.id)">
              <div class="d-flex justify-content-between align-items-center">
                <h4 class="title pr-3 pointer" style="font-size:1.1rem" @click="goCourse(item.package_course.id)">{{item.package_course.name}}</h4>
                <!-- <span class="pointer d-inline-flex align-items-center" @click="goCourse(item.package_course.id)">
                  <img src="../assets/image/icon&btn/icon_have_btn_function/btn_function_show_list.png" alt="">
                  <span>看更多</span>
                </span> -->
              </div>
              <div class="picture image-box pointer christmas-new-cover">
                <img class="cover" :src="item.cover" alt="">
                <div v-if="normalizeCefrLevels(item.cefr).length" class="image-level-list">
                  <span v-for="level in normalizeCefrLevels(item.cefr)" :key="level" class="image-level-badge">{{ level }}</span>
                </div>
                <span class="new-label christmas-new-label">NEW</span>
              </div>
              <div class="ml-2">
                <p class="m-0" style="font-size:1.1rem">
                  {{item.name}}
                </p>
                <p class="mx-0 mb-2" v-html="forceToJap(item.name_en)" style="font-size:1rem">
                  {{item.name_en}}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="recordLesson.length>0">
      <div class="col-md-12">
        <div class="d-flex my-3">
          <h3 class="title pr-3">
            {{ $t('Home.Learning_History') }}
          </h3>
          <div class="line"></div>
        </div>
        <div class="row my-3">
          <div class="col-lg-3 col-md-6 col-12" v-for="(item, index) in recordLesson.slice(0,4)" :key="index">
            <div @click="goPage(item.id)">
              <div v-if="magEnable === false" class="picture image-box pointer">
                <img class="cover" :src="item.cover" alt="">
                <div v-if="normalizeCefrLevels(item.cefr).length" class="image-level-list">
                  <span v-for="level in normalizeCefrLevels(item.cefr)" :key="level" class="image-level-badge">{{ level }}</span>
                </div>
              </div>
              <div v-else class="picture image-box-m pointer"  >
                <img class="cover" :src="item.cover" alt="">
              </div>
              <div class="ml-2">
                <p class="m-0" style="font-size:1.1rem">
                  {{item.name}}
                </p>
                <p class="m-0" v-html="forceToJap(item.name_en)" style="font-size:1rem">
                  {{item.name_en}}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="magEnable === false">
      <div class="col">
        <div class="d-flex my-3">
          <h3 class="title pr-3">{{ $t('Home.Recommend') }}
          </h3>
          <div class="line"></div>
        </div>
          <div class="row my-3">
            <div class="col-lg-3 col-12" v-for="(item, index) in recommendLesson.slice(0,4)" :key="index">
            <div class="recommend-item d-sm-flex my-2">
              <div class="recommend-cover pointer" @click="goCourse(item.id)">
                <img class="m-auto" :src="item.cover" alt="">
                <div v-if="normalizeCefrLevels(item.cefr).length" class="recommend-cefr-list">
                  <span v-for="level in normalizeCefrLevels(item.cefr)" :key="level" class="recommend-cefr-badge">{{ level }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="magEnable === false">
      <div class="col">
        <div class="d-flex my-3">
          <h3 class="title pr-3">{{ $t('Home.Learning_Guides') }}</h3>
          <div class="line"></div>
        </div>
        <div class="row my-3 align-items-stretch" style="postition: relative">
          <div class="col-md-3">
            <div style="border:solid 1px #ccc;height:100%">
              <div class="cefr-guide-heading">
                <h4 class="p-2" style="color:#fff">CEFR定義</h4>
              </div>
              <div class="p-2">
                <div>
                  <p style="font-size: .9rem">
                    CEFR為歐洲語言共同參考標準（Common European Framework of Reference for Languages: Learning, Teaching, Assessment，常簡稱CEFR）是歐洲委員會在2001年11月通過的一套建議標準，為歐洲語言在評量學習、教學、評量架構和教學指引、考試、教材所提供的基準，可用來評估語言學習者在所學語言的成就，並將語言程度所應具備的能力分成各個等級，含聽、說、讀、寫、連續的表達和參與對話五項技能分級界定。CEFR受到多國政府、企業與學術機構認可，許多國際性英檢，如 <a target="_blank" href="https://www.toeic.com.tw/Upload/att/2020-10/202411221119403815758483.pdf">多益</a>、托福、雅思皆已採用。
                  </p>
                </div>
              </div>
              <div style="text-align: right">
                <button type="button" @click="goExam()" class="btn btn-danger mx-2 mb-2">了解目前能力</button>
              </div>
            </div>
            <!-- <div style="text-align: left">
              <button type="button" class="btn btn-danger my-2">了解目前能力</button>
            </div> -->
          </div>
          <div class="col-md-9">
            <div class="cefr-pic">
              <img style="width:100%;" src="../assets/image/LLPRO_CEFR_banner_bg.png" alt="">
              <!-- <img style="width:15%; position:absolute; bottom:16%; left:5%; opacity:50%;" src="../assets/image/LLPRO_CEFR_banner_woman.png" alt=""> -->
              <img class="cefr-man" src="../assets/image/LLPRO_CEFR_banner_man.png" alt="">
              <div class="m-3 p-2 cefr-content" v-for="(item, index) in chats" :key="index">
                <div v-if="index === currentBar">
                  <div class="d-flex">
                    <div class="cefr-title mr-2 mb-3">
                      <span class="cefr-icon"> {{item.level}}</span>
                      <span class="mx-2">
                        <span>{{item.name}} {{item.subName}}</span>
                        |
                        <span class="cefr-range" v-if="item.range">{{item.range}}​</span>
                      </span>
                    </div>
                  </div>
                  <div class="mb-3">
                    <button :class="{'active':isAdvice === true}" @click="infoToggle(true)" type="button" class="btn btn-sm btn-outline-secondary">能力說明</button>
                    <button :class="{'active':isAdvice === false}" @click="infoToggle(false)" type="button" class="btn btn-sm btn-outline-secondary mx-2">學習建議</button>
                    <button  @click="goIndex" type="button" class="btn btn-sm btn-outline-secondary">課程總覽</button>
                  </div>
                  <div v-if="isAdvice">
                    <div v-for="(item, index) in item.text" :key="index">
                      <p>{{index+1}}. {{item}}​</p>
                    </div>
                  </div>
                  <div v-else>
                    {{item.advice}}
                  </div>
                  </div>
                </div>
              <div class="d-flex chart">
                <div class="bar-layout" v-for="(item, index) in chats" :key="index">
                  <div class="mx-auto bar pointer d-flex justify-content-center align-items-end" @click="currentBar = index" :style="{height: item.bar}" :class="{'active': currentBar === index}">
                    <div class="bar-text">
                      {{item.level}}
                    </div>
                  </div>
                  <div class="bar-name">{{item.name}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapActions, mapGetters } from 'vuex'
import Player from 'live-player/dist/Player'
import DailyNews from '@/components/DailyNews.vue'
import DailySentence from '@/components/DailySentence.vue'
import DailyModal from '@/components/DailyModal.vue'
import apiLibrary from '../store/library/api'
import api from '../store/api'

export default {
  name: 'Home',
  components: {
    Player,
    DailyNews,
    DailySentence,
    DailyModal
  },
  computed: {
    ...mapGetters([
      'authorized',
      'authInfo'
    ]),
    magOnly () {
      if(this.authInfo.user.magOnly) {
        return true
      } else {
        return false
      }
    },
    magEnable () {
      if(this.authInfo.user.magEnable) {
        return true
      } else {
        return false
      }
    },
    cefr () {
      switch (this.currentBar) {
        case 0:
          return 'A1'
        case 1:
          return 'A2'
        case 2:
          return 'B1'
        case 3:
          return 'B2'
        case 4:
          return 'C1'
      }
      return null
    }
  },
  watch: {
    dailySentencesType (val) {
      if (val) {
        this.getDailySentences()
      }
    },
    selectedChannel (val) {
      if (val) {
        this.getMagLesson(val)
      }
    }
  },
  data () {
    return {
      audioData: null,
      recentLessons: [],
      recommendLesson: [],
      recordLesson: [],
      dailyNews: [],
      dailyEnglish: null,
      dailySentencesList: [],
      dailySentencesType: [],
      channels: [],
      selectedChannel: 0,
      magLesson: [],
      travelTaiwan: null,
      hotWord: null,
      exam: null,
      isAdvice: true,
      isFinished: false,
      chats: [
        {
          name: '基礎級',
          subName: 'Breakthrough',
          level: 'A1',
          range: 'TOEIC: < 225',
          bar: '8%',
          text:[
            '能夠理解和使用非常簡單之詞彙來做日常表達，以滿足基本需求。',
            '能夠介紹自己與他人，並就個人背景提出及回答問題（如住址、認識的人、擁有的物品等）。​',
            '在對方講話清晰緩慢且提供幫助的情況下，能夠以簡單的方式交流。'
          ],
          advice: '此階段學員建議從發音規則開始打好基礎，學習英文的音節、重音及語調，接著熟記基礎單字。有了一定的字彙量後，即可學習簡易的生活實用句子，並可搭配互動課程內的跟讀功能，藉由聆聽原音與實際開口練習，為基本表達能力奠定基礎。建議學習課程類別與名稱：【生活英文】我想學好發音、我想學好基礎1200字。【學習資源】日常對話好用句、我想學社交必備句。'
        },
        {
          name: '初級',
          subName: 'Waystage',
          level: 'A2',
          range: 'TOEIC: 225-550​',
          bar: '16%',
          text:[
            '能夠理解與日常生活切身相關的句子和常用的表達方式，例如個人和家庭的基本資訊、購物、當地環境、工作等。​',
            '能夠就單純的例行事務進行溝通，直接交流熟悉的例行事項的信息。​',
            '能夠用簡單的方式描述自己的背景、周圍環境和切身領域中的事物。​'
          ],
          advice: '此階段學員已具備基本字彙量，建議進一步熟記互動課程中的單字片語用法，利用字典的查詢與收藏功能，建立專屬自己的字庫，並交互運用課程中的文字學習模式反覆聆聽及跟讀，除可增進閱讀能力，也可培養各種生活、社交、旅遊等情境的問答能力。另針對想提高多益分數的學員，則建議先透過名師講解的文法與聽力影片課程，釐清基礎文法觀念及熟悉測驗的基本應考技巧，並熟記多益必考單字。建議學習課程類別與名稱：【生活英文】日常實用情境、去旅行吧、週末放輕鬆、節慶文化。【多益專區】必考單字、多益文法解題、多益聽力解析。【學習資源】我想學社交必備句、易混淆字大解析、英文好好玩。'
        },
        {
          name: '中級',
          subName: 'Threshold',
          level: 'B1',
          range: 'TOEIC: 550-785​',
          bar: '24%',
          text:[
            '對於工作或休閒等領域中經常接收之清晰標準訊息，能夠理解其重點。',
            '在使用該語言的地區旅行時，能夠應對可能出現的大多數情況。',
            '能夠在熟悉或個人感興趣的主題上產出簡單的文稿。​',
            '能描述經歷、事件、夢想、希望和抱負，並簡要說明意見和計劃的理由。'
          ],
          advice: '此階段學員已具備一定的閱讀能力與字彙量，也能在工作時，閱讀例行的英文文件。建議可進一步觸及各類的生活題材，拓展知識的同時，又能增進英語的語感與口語表達能力。另可搭配基礎商業英文課程，透過情境影片學習職場的基本詞彙和實用語句，訓練工作上的溝通應對。針對想突破多益高分的學員，則建議熟悉文法觀念及加強應考技巧，並利用專區內的多益練習試題，提升應考實力。建議學習課程類別與名稱：【生活英文】健康好食尚、知識大百科、老外帶你遊臺灣。【商業英文】商務會議、電話客服、社交接待、團隊溝通、上班族輕鬆學、商英必備句。【多益專區】多益文法解題、多益聽力解析、多益練習考。【學習資源】最新話題字。'
        },
        {
          name: '中高級',
          subName: 'Upper Intermediate',
          level: 'B2',
          range: 'TOEIC: 785-945​',
          bar: '32%',
          text:[
            '能夠理解具體和抽象主題的複雜文本，包括個人專業領域中的技術性討論。',
            '能夠以流暢和自然的方式與母語人士進行即時交流。',
            '能夠清晰詳細地撰寫各種主題的文章，並闡述對議題的看法及說明優缺點。'
          ],
          advice: '此階段學員已能理解不同主題、具體或抽象的話題，也可在工作場合中用英語開會、報告或介紹產品。建議學員除加強生活英文的廣度，可著重於商務英語的專業能力，藉由短劇模擬的商務情境及中外師搭配的重點解析，掌握跨文化溝通的要領與用語。更可進一步從短篇報導的新聞英語，逐漸累積時事詞彙並訓練英語聽力。若準備參加TOEIC檢定，也可先利用多益專區內的模擬試題來加強作答速度與提升正確率。建議學習課程類別與名稱：【生活英文】健康好食尚、知識大百科。【商業英文】商務會議、簡報英語、業務行銷、商展旅行、經營管理、商務風格誌。【新聞英語】CNN全球新聞。【多益專區】多益練習考。'
        },
        {
          name: '高級',
          subName: 'Advanced',
          level: 'C1',
          range: 'TOEIC: > 945',
          bar: '40%',
          text:[
            '能夠理解各種難度高且較長的文本，並能看出隱含的意義。​',
            '能夠自然流利地表達自己，不需費力思索措辭。​',
            '能夠靈活有效地使用語言，滿足社交、學術和專業的用途。​',
            '能撰寫條理分明且結構良好的文章，並清楚地呈現內容架構及其內在關聯。'
          ],
          advice: '此階段的學員除自身領域外，也能理解或談論跨領域的英文內容，並於商務場合流利地表達自我。建議學員除加強生活英文的深度，可多從新聞英語的長篇報導增進國際觀，學習最道地的口語說法，並熟悉各國口音。更可藉由關閉影片字幕的模式，訓練英語聽力與理解能力。除可依自身需求選擇課程學習，建議學習重點課程類別與名稱：【生活英文】健康好食尚、知識大百科、名人超新星。【新聞英語】品牌專題、名人專訪、科技創新、商業財經、生活趨勢、人文藝術。'
        }
      ],
      currentBar: 0
    }
  },
  async mounted () {
    await this.getUser()
    this.scrollTop()
    this.getChannel()
    if (this.authorized) {
      if (this.$store.state.auth.user.aiOnly === true) {
        this.$router.push({ name: 'ai_assistantIntro' })
      } else {
        this.$router.push({ name: 'Home' })
      }
      this.getExam()
      this.getDailySentencesList()
      this.getDailySentences()
      if (this.authInfo.user.forcePreTest) {
        if (this.authInfo.user.isFinishPreTest) {
          if (this.magEnable) {
            this.getEnglish()
            this.getNews()
          } else {
            this.getEnglish()
            this.getHotWord()
            this.getTravelTaiwan()
            this.getNews()
          }
        } else {
          this.$router.push({ name: 'Exam-area' })
        }
      } else {
        if (this.magEnable) {
          this.getEnglish()
          this.getNews()
        } else {
          this.getNews()
          this.getEnglish()
          this.getHotWord()
          this.getTravelTaiwan()
        }
      }
      this.getRecentLessons()
      this.getRecordLessons()
      this.getRecommendLessons()
    } else {
      this.$router.push({ name: 'Login' })
    }
  },
  methods: {
    ...mapActions({
      getUser: 'getUser'
    }),
    async getDailySentencesList () {
      const { data } = await apiLibrary.get('/v1/daily-sentences/categories/livelearningpro')
      this.dailySentencesList = data
      // 預設type為第一顆按鈕
      this.dailySentencesType = data[0].id
    },
    async getDailySentences () {
      const { data } = await apiLibrary.get(`/v1/daily-sentences?category=${this.dailySentencesType}`)
      this.checkCollections([data.data[0]])
    },
    selectType (id) {
      this.dailySentencesType = id
    },
    async getNews() {
      try {
        const params = {
        page: 1,
        pageSize: 1,
        orderBy: 'desc',
        categories: 2,
        // type: 'daily_news'
      }
      const { data } = await api.get('/contents/courses/', { params })
      this.dailyNews = data.data
      } catch (error) {
        if (error.response.data.code=== '3002') {
          this.isFinished === false
        }
      }
    },
    async getMagLesson (id) {
      const params = {
        pageIndex: 1,
        pageSize: 12,
        channel: id
      }
      const { data } = await api.get('/contents/package_courses', { params })
      this.magLesson = data.data
    },
    goMag (el) {
      this.$router.push({ name: 'Course', params: { channel: el.child.at(-1).items.at(-1).id } })
    },
    async getEnglish() {
      const params = {
        page: 1,
        pageSize: 1,
        sortBy: 'public_at',
        order: 'desc'
      }
      const { data } = await api.get('/contents/package_courses/282/courses', { params })
      this.dailyEnglish = data.data[0]
    },
    async getHotWord() {
      const params = {
        page: 1,
        pageSize: 1,
        sortBy: 'public_at',
        order: 'desc'
      }
      const { data } = await api.get('/contents/package_courses/277/courses', { params })
      this.hotWord = data.data[0]
    },
    async getTravelTaiwan() {
      const params = {
        page: 1,
        pageSize: 1,
        sortBy: 'public_at',
        order: 'desc'
      }
      const { data } = await api.get('/contents/package_courses/279/courses', { params })
      this.travelTaiwan = data.data[0]
    },
    async getRecentLessons() {
      const { data } = await api.get('contents/courses/recent')
      this.recentLessons = data.data
    },
    async getRecordLessons() {
      const params = {
        page:1,
        pageSize:4
      }
      const { data } = await api.get('/contents/courses/history', params)
      this.recordLesson = data.data
    },
    async getRecommendLessons() {
      const { data } = await api.get('contents/courses/recommend')
      // let item = data.data[Math.floor(Math.random()*data.data.length)]
      this.recommendLesson = data.data
    },
    async checkCollections (el) {
      let str = ''
      let checkArray = []
      for (const item in el) {
        str += el[item].id + ','
      }
      try {
        const { data } = await api.get(`collections/daily_sentence/check?ids=${str}`)
        checkArray = data.data
      } catch (error) {
        console.error(error.response.data)
      }
      for (const item in el) {
        const idx = checkArray.indexOf((el[item].id))
        if (idx > -1) {
          el[item].collection = true
        } else {
          el[item].collection = false
        }
      }
      this.audioData = el
    },
    async getLessonId (id) {
      const { data } = await api.get(`/contents/courses/${id}`)
      if (data.status === 'Success') {
        this.$nextTick(() => {
          // this.getParents(data.data.category_id)
        })
        return data.data
      }
    },
    async getExam () {
      const { data } = await api.get('/contents/exams?page=1&pageSize=10&type=classify')
      this.exam = data.data[0]
    },
    goIndex () {
      const vm = this
      this.$router.push({
        name: 'Search',
        query:{
          cefr: vm.cefr,
        }
      })

    },
    goExam() {
      this.$router.push({ name: 'Exam-area' })
    },
    async goPage (id) {
        await this.getLessonId(id).then((val) => {
        this.$router.push({ name: 'CourseLesson', params: { lesson: val.id, courseId: val.sections[0].data.view_id||val.sections[0].id } })
      } )
    },
    async goList ()  {
      this.$router.push({ name: 'Search' })
    },
    async goCourse (id) {
      this.$router.push({ name: 'Course', params: { channel: id } })
    },
    normalizeCefrLevels (cefr) {
      if (!cefr) {
        return []
      }
      if (Array.isArray(cefr)) {
        return cefr.filter(Boolean).map(level => String(level).trim()).filter(Boolean)
      }
      return String(cefr).split(',').map(level => level.trim()).filter(Boolean)
    },
    async goModalList (id) {
      this.$router.push({ name: 'modalList', params: { courseId: id } })
    },
    async getLessonId (id) {
      const { data } = await api.get(`/contents/courses/${id}`)
      if (data.status === 'Success') {
        return data.data
      }
    },
    infoToggle (el) {
      this.isAdvice = el
    },
    async getChannel () {
      const { data } = await api.get('/contents/channels?show_magazines=1')
      this.channels = data.data
      this.selectedChannel = data.data[0].id
    },
    forceToJap (sent, hidePinyin = false) {
      const split = sent.split(/{(.+?)}/)
      let newSent = ''
      for (const i in split) {
        if (split[i].indexOf('=') > -1) {
          if (!hidePinyin) {
            newSent += '<ruby>' + split[i].split(/=/)[0] + '<rt>' + split[i].split(/=/)[1] + '</rt></ruby>'
          } else {
            newSent += split[i].split(/=/)[0]
          }
        } else {
          newSent += split[i]
        }
      }
      return newSent
    },
    scrollTop () {
    const currentScroll = document.documentElement.scrollTop || document.body.scrollTop
      if (currentScroll > 0) {
        window.scrollTo(0, 0)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  @import "../assets/styles/color.scss";
  @import "../assets/styles/custom.scss";

  .container {
    text-align: left;
  }
  .title {
    font-size: 1.4rem;
    font-weight: bolder;
    color: $main-color;
    background-color: $white-color;
    z-index: 10;
  }
  .latest-title {
    position: relative;
    padding-right: 44px !important;
  }
  .latest-title-new {
    position: absolute;
    top: -12px;
    right: 20px;
    color: #ff8a00;
    font-size: .7rem;
    line-height: 1;
    vertical-align: middle;
    animation: latest-new-breath 1.6s ease-in-out infinite;
  }
  @keyframes latest-new-breath {
    0%,
    100% {
      transform: scale(1);
      text-shadow: 0 0 0 rgba(255, 138, 0, 0);
    }
    50% {
      transform: scale(1.12);
      text-shadow: 0 0 10px rgba(255, 138, 0, .65);
    }
  }
  .dic-btn{
    .dic-btn-h {
      display: none;
    }
  }
  .dic-btn:hover {
    .dic-btn-d {
      display: none;
    }
    .dic-btn-h {
      display: inline;
    }
  }
  .line {
    width: 98%;
    position: absolute;
    top: 32px;
    border-top: black 1px solid;
  }
  .hint {
    font-weight: 800;
    font-size: 1rem;
    color: rgb(182, 180, 180);
  }
  .picture .cover:hover {
    transform: scale(1.05)  translate(-50%,-50%);
    filter:opacity(.8);
  }
  .picture {
    position:relative;
    min-height: 150px;
    max-height: 150px;
    overflow: hidden;
    .cover {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition:all 0.2s ease;
    }
    .tag {
      width: 40px;
      position: absolute;
      padding: 10px;
    }
    .new-label {
      background-color: $main-color;
      padding: 0 30px 0 60px;
      color: #fff;
      font-weight: bolder;
      font-size: 1rem;
      transform: rotate(35deg);
      position: absolute;
      top: 0;
      right: -8%;
      z-index: 50;
    }
  }
  .recommend-cover {
    display: inline-block;
    position: relative;
    max-width: 265px;
    width: 100%;
    text-align: center;

    img {
      display: block;
      max-width: 265px;
      width: 100%;
    }
  }
  .recommend-cover:hover {
    filter: brightness(1.2);
    box-shadow: #0006 5px 5px 10px;
  }

  .recommend-cefr-list {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 5;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    align-items: center;
    gap: 4px;
    max-width: calc(100% - 20px);
    pointer-events: none;
  }
  .recommend-cefr-badge {
    min-width: 38px;
    padding: 2px 8px;
    border-radius: 4px;
    background-color: $main-color;
    color: #fff;
    font-size: 1rem;
    font-weight: 800;
    line-height: 1.4;
    text-align: center;
    box-shadow: 0 1px 2px rgba(0, 0, 0, .2);
  }
  .cefr-guide-heading {
    background-color: $main-color;
    text-align: center;
  }
  .magazine:hover {
    filter: brightness(1.2);
    box-shadow: 4px 2px 2px 2px rgba(0, 0, 0, 0.2);
  }
  .magazine-disable {
    position: relative;
    .disable-box {
      position: absolute;
      top: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      h5 {
        @include center();
        border: 1px solid #fff;
        padding: 8px;
        color: #fff;
      }
    }

  }
  .magazine-name {
    margin: 10px 0;
    font-weight: bold;
    text-align: center;
  }
  .image-level-list {
    position: absolute;
    top: 10px;
    left: 10px;
    z-index: 5;
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    max-width: calc(100% - 20px);
    pointer-events: none;
  }
  .image-level-badge {
    min-width: 38px;
    padding: 2px 8px;
    border-radius: 4px;
    background-color: $main-color;
    color: #fff;
    font-size: 1rem;
    font-weight: 800;
    line-height: 1.4;
    text-align: center;
    box-shadow: 0 1px 2px rgba(0, 0, 0, .2);
  }
  .cefr-pic {
    position: relative;
    .cefr-man {
      width: 20%;
      position: absolute;
      right: 0;
      bottom: 42%;
      z-index: 20;
      pointer-events: none;
    }
    .cefr-content {
      .cefr-title {
        font-size: 1.2rem;
        font-weight: bold;
        color: $main-color;
        .cefr-icon {
          color: #fff;
          background-color: $main-color;
          padding: 2px 8px;
          border-radius: 4px;

        }
      }
      .bg-danger {
        color: #fff;
      }
      border-radius: 20px;
      width: 70%;
      position: absolute;
      top: 0;
      z-index:50 !important;
    }
    .btn:hover,
    .btn:focus {
      outline: none;
      box-shadow: none !important;
    }
    .bar-layout {
      width: 100%;
      position: relative;
      .bar-name {
        font-weight: bold;
        position: absolute;
        bottom:10px;
        text-align:center;
        width:100%;
      }
      .bar {
        border-radius: 10px 10px 0 0;
        width:50%;
        background:rgb(255, 185, 185);
        position: absolute;
        bottom: 40px;
        right: 25%;
        transition: all .5s cubic-bezier(0.42, 0, 0.58, 1.0);
        .bar-text {
          color:#fff;
        }
      }
      .active {
        background: $main-color;
      }
    }
  }
  .subtitle {
    margin: 2%;
    width: 96%;
    line-height: 3rem;
    font-size: 1.5rem;
    box-shadow: 4px 2px 2px 2px rgba(0, 0, 0, 0.2);
  }
  .pop-title {
    h4 {
      margin: 0;
      font-size: 1rem !important;
    }
  }
  .chart {
    width: 100%;
    height: 100%;
    position: absolute;
    bottom: 0;
  }
  .scroll-box {
    height: 450px;
    overflow-y: auto;
    overflow-x: hidden;
    //border: 1px solid #ccc;
    padding: 10px;
  }
  .item-flex {
    padding: 10px;
    width: 100%;
  }
  @media (min-width: 580px) {
    .item-flex {
      width: 20%;
    }
    .recommend-cover {
      margin: 5% 10%;
      width: 80%;
    }
  }
  @media(max-width: 580px){
    .recommend-item {
      text-align: center;
    }
    .recommend-cover {
      margin-right: auto;
      margin-left: auto;
    }
    .magazine-disable {
      display: none;
    }
    .magazine-name {
      display: none;
    }
  }
  @media(max-width: 1280px){
    .cefr-pic {
      margin-top: 20px;
      width: 100%;
      height: 550px;
      border-radius: 10px;
      background: url('../assets/image/LLPRO_CEFR_banner_bg.png');
      background-size: cover;
      background-position: center;
      img {
        display: none;
      }
    }
    .cefr-content {
      p {
        padding: 0 20px 0 0;
      }
      width: 100% !important;
    }
    .active {
      background-color: #6c757d;
      color: #fff;
    }
    .select-box {
      border: 0px solid black !important;
      .maintitle {
        height: 10vh;
        h2 {
          position: relative;
          left: 0;
          text-align: center;
        }
      }
    }
  }
</style>
